import { render } from "./ImplantsQuality.vue?vue&type=template&id=e89515e4"
import script from "./ImplantsQuality.vue?vue&type=script&lang=js"
export * from "./ImplantsQuality.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__